// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9516) return "static/chunks/9516-1c56035b21c8f82d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1202":"31b66820e3ba238b","9570":"d7e19c4af6382b5f"}[chunkId] + ".js";
};